/**
 * @generated SignedSource<<fe7ecf5c8d681266aeca0c3195468f67>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Symptom = "FUNCTIONAL_DISORDER" | "LIMITED_RANGE_OF_MOTION" | "PAIN" | "PAIN_RELATED_MAL_POSITION";
import { FragmentRefs } from "relay-runtime";
export type deTherapyPrescriptionFragment$data = {
  readonly additionalInformation: string | null;
  readonly concludedAt: string | null;
  readonly concludedBy: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly diagnosisCode: string;
  readonly fileMetadata: {
    readonly documentType: string;
    readonly extension: string;
    readonly lengthInKilobytes: number;
  } | null;
  readonly frequency: string;
  readonly id: string;
  readonly otherSymptoms: string | null;
  readonly progressNoteId: string;
  readonly requestTherapyReport: boolean;
  readonly signedAt: string | null;
  readonly signedBy: string | null;
  readonly symptoms: ReadonlyArray<Symptom> | null;
  readonly therapy: string;
  readonly treatmentUnit: number;
  readonly updatedAt: string | null;
  readonly updatedBy: string | null;
  readonly " $fragmentType": "deTherapyPrescriptionFragment";
};
export type deTherapyPrescriptionFragment$key = {
  readonly " $data"?: deTherapyPrescriptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deTherapyPrescriptionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "deTherapyPrescriptionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentUnit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frequency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestTherapyReport",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "diagnosisCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symptoms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherSymptoms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalInformation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressNoteId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "concludedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "therapy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DocumentFileMetadata",
      "kind": "LinkedField",
      "name": "fileMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "documentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extension",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lengthInKilobytes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_TherapyPrescription",
  "abstractKey": null
};

(node as any).hash = "6bfadad9a8157db0bb4fd99b8fc7d598";

export default node;
